function infoController(WS) {
  "ngInject";
  const vm = this;
  WS.getScache('societes')
  .then(function (response) {
    vm.societes = response.data[0];
    return Promise.all([
      $http.get('https://api.sav.priorityexpeditions.com/api/v1/infoparametrages', { cache: false }),
      $http.get('https://api.sav.priorityexpeditions.com/api/v1/infodepots', { cache: false })
    ]);
  })
  .then(function ([res1, res2]) {
    vm.infoparametrages = res1.data;
    vm.infodepots = res2.data;
    console.log("done :");
  })
  .catch(function (error) {
    console.error("Erreur :", error);
  });

}
export default {
  name: "infoController",
  fn: infoController,
};
